import { useCallback } from 'react';

import { TranslatableText, useTranslate } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../translations';

import { DEFAULT_INSURANCE_TYPE } from './common.constants';
import { MedicalLeaveCommonFormController, MedicalLeaveFormsInsuranceType } from './common.types';
import { StyledMedicalLeaveFormInsurer } from './StyledMedicalLeaveFormInsurer';

const useTriggerLabelExtractor = (): ((currentValue?: MedicalLeaveFormsInsuranceType) => string) => {
   const translate = useTranslate();
   return useCallback((currentValue) => translate(commonTranslationKeys[currentValue!]), [translate]);
};

const insuranceTypes: MedicalLeaveFormsInsuranceType[] = [
   DEFAULT_INSURANCE_TYPE,
   'KRUS',
   'OTHER_POLAND',
   'OTHER_FOREIGN',
];

type MedicalLeaveFormInsurerProps = {
   readonly controller: MedicalLeaveCommonFormController;
   readonly label: TranslatableText;
};

export const MedicalLeaveFormInsurer = (props: MedicalLeaveFormInsurerProps): JSX.Element => {
   const handleSelect = useCallback(() => {
      props.controller.reset(
         {
            ...props.controller.getValues(),
            payers: [],
         },
         {
            dirtyFields: true,
            errors: false,
            isDirty: true,
            isSubmitted: true,
            isValid: true,
            submitCount: true,
            touched: true,
         }
      );
   }, [props.controller]);

   return (
      <StyledMedicalLeaveFormInsurer>
         <Select<MedicalLeaveFormsInsuranceType>
            triggerLabelExtractor={useTriggerLabelExtractor()}
            controller={props.controller.register('insuranceType', { required: true })}
            label={props.label}
            testId='insurer'
            onSelect={handleSelect}
         >
            <Select.List items={insuranceTypes}>
               {(insuranceType) => (
                  <Select.Item
                     testId={insuranceType}
                     item={insuranceType}
                     label={commonTranslationKeys[insuranceType]}
                  />
               )}
            </Select.List>
         </Select>
      </StyledMedicalLeaveFormInsurer>
   );
};
